import useRequestContext from 'hooks/user/useRequestContext';
import CookieConsentPlaceholderButton from './CookieConsentPlaceholderButton';
import CookieConsentLoader from './CookieConsentLoader';

/**
 * Component for initial page load
 */
export default function CookieConsentRenderer() {
    const { shouldLoadCookieConsentOnPageLoad } = useRequestContext();

    // Load consent script if consent doesn't exist.
    // Otherwise, load placeholder button

    if (shouldLoadCookieConsentOnPageLoad) {
        return <CookieConsentLoader />;
    }

    return <CookieConsentPlaceholderButton />;
}
